import { render } from "./NotesApp.vue?vue&type=template&id=c87ede5e&scoped=true"
import script from "./NotesApp.vue?vue&type=script&lang=js"
export * from "./NotesApp.vue?vue&type=script&lang=js"

import "./NotesApp.vue?vue&type=style&index=0&id=c87ede5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87ede5e"]])

export default __exports__